"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchThemesRequestStatus = exports.getThemes = void 0;

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getThemes = function getThemes(state) {
  return state.themes;
};

exports.getThemes = getThemes;
var getFetchThemesRequestStatus = (0, _getRequestStatus.default)(_actions.ThemeActionTypes.FETCH_THEMES);
exports.getFetchThemesRequestStatus = getFetchThemesRequestStatus;